import * as marked from 'marked';

export default ['$rootScope', ( $rootScope ) => {

  const translateText = (text, removeP) => {
    if ( text ) {
      let returnText = marked.parse(text);

      if (removeP && returnText) {
        returnText = returnText.replace(new RegExp('<\/?p>', 'g'), '');
      }
      return returnText;
    }
  };

  return {
    translate: (text, removeP = undefined) => translateText(text, removeP),
    translatePure: text => { text? marked.parse(text) : '';}
  };
}];


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/markdown.service.js